import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Root = styled.div`
  padding: 2rem 15px 0;
  text-align: center;
`;

const NotFound: React.FunctionComponent<any> = () => (
  <Root>
    <h1>
      <FormattedMessage id="not-found.header" />
    </h1>
    <p>
      <FormattedMessage id="not-found.description" />
    </p>
    <Link to={{ pathname: '/' }}>
      <FormattedMessage id="not-found.link" />
    </Link>
  </Root>
);

export default NotFound;
